import React from 'react';
import { Badge } from '.';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import { DATE_LOCALE } from './language-to-locales';
export function DeveloperSaleBadge({ showBorder, size = 'small', amount, endDate, languageCode = 'en', }) {
    const { t } = useEssentials();
    return (React.createElement(Box, { marginTop: "2px" },
        React.createElement(Badge, { skin: "standard", type: "outlined", dataHook: "dev-sale-badge", uppercase: false, showBorder: showBorder, size: size, tooltipContent: 
            // @ts-expect-error wds types are incompatible
            React.createElement(Text, { size: "small", weight: "thin", skin: "light" }, t('developer.sale.badge.tooltip', {
                amount,
                endDate: endDate
                    ? endDate.toLocaleDateString(DATE_LOCALE[languageCode], {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        timeZone: 'UTC',
                    })
                    : '',
            })) },
            React.createElement(Box, { marginTop: "0px", color: "#116DFF", fontSize: "small" }, t('developer.sale.badge', { amount })))));
}
//# sourceMappingURL=dev-sale-badge.js.map